import { useProductRefreshExperienceEnabled } from './useProductRefreshExperienceEnabled'
import { APP_SHELL_FLAG_KEY } from '../shell_layout/shellConstants'

/**
 * Gates the new product refresh app shell layout (nav, routes, page chrome).
 *
 * Alpha (`ap_rebrand_app_shell_ia`, frozen) or global beta cohort, with the beta gate open.
 * Prefer this hook over reading `APP_SHELL_FLAG_KEY` directly.
 */
export function useProductRefreshAppShell(): boolean {
  return useProductRefreshExperienceEnabled(APP_SHELL_FLAG_KEY)
}
